// Phase 9B — IntelligencePage.
//
// Route-level wrapper for User Intelligence / CRM dashboard.

import { UserIntelligencePage } from "../../modes/intelligence/UserIntelligencePage.tsx";

export function IntelligencePage(): JSX.Element {
  return <UserIntelligencePage />;
}
